import { merge, of } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { selectPlayerLevel } from "../../selectors/selectPlayerLevelInfo";
import { TypeActionModal } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionOngoingPurchaseInfo, } from "../ongoing-purchase/actionOngoingPurchase";
import { actionViewportSmoothZoom } from "../viewport/actionViewport";
import { TypeActionScene } from "./actionScenes";
import { IdScene } from "./types/IdScene";
export var epicSceneInitialZoom = function (action$, state$) {
    var actionCloseLevelUp$ = action$.pipe(filter(function (action) {
        var state = state$.value;
        var playerLevel = selectPlayerLevel(state);
        return (playerLevel === 2 &&
            ((action.type === TypeActionModal.CloseLast &&
                state.modals.modalStack.length === 0) ||
                (action.type === TypeActionModal.Close && action.modalId === IdModal.LevelUp)));
    }));
    var actionCloseInterstitialOffer$ = action$.pipe(filter(function (action) {
        var state = state$.value;
        var playerLevel = selectPlayerLevel(state);
        return (playerLevel > 2 &&
            (action.type === TypeActionOngoingPurchaseInfo.CloseAll ||
                (action.type === TypeActionModal.CloseLast &&
                    state.modals.modalStack.length === 0)));
    }));
    return action$.pipe(filter(function (_a) {
        var type = _a.type, sceneId = _a.sceneId;
        return type === TypeActionScene.Swap && sceneId === IdScene.PlayerBase;
    }), switchMap(function () {
        return merge(actionCloseLevelUp$, actionCloseInterstitialOffer$).pipe(take(1), switchMap(function () {
            return of(actionViewportSmoothZoom());
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/epicSceneInitialZoom.ts
// module id = 2131
// module chunks = 3